import type { ITrendsBarValue } from "pro-features/components/TrendsBar/src/TrendsBar";

export const trendMock = [
    { value: 1, tooltip: "" },
    { value: 2, tooltip: "" },
    { value: 3, tooltip: "" },
] as ITrendsBarValue[];
